import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "image-component-viewer" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_image = _resolveComponent("icon-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.image && _ctx.item.image.publicUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.item.image.publicUrl,
          style: _normalizeStyle({
                 width: _ctx.item.width + 'px',
                 height: _ctx.item.height + 'px',
                 objectFit: _ctx.item.objectFit
             }),
          alt: "Immagine template"
        }, null, 12, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "placeholder-image",
          style: _normalizeStyle({
                 width: _ctx.item.width + 'px',
                 height: _ctx.item.height + 'px'
             })
        }, [
          _createVNode(_component_icon_image),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "small text-muted mt-1" }, "Immagine", -1))
        ], 4))
  ]))
}